export default "__VITE_ASSET__fcc3d228__"